import React, { useMemo } from 'react';
import { useGetClinicUsersQuery } from 'shared/types/graphql';
import ClinicAvatar from 'shared/components/Avatars/ClinicAvatar';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';
import useClinicUser from 'shared/hooks/useClinicUser';
import { IAvatarGroupSelectOption } from '.';

interface IUseAvatarGroupSelectOptionsProps {
  selectedUserIds?: string[];
}

export const useAvatarGroupSelectOptions = ({
  selectedUserIds,
}: IUseAvatarGroupSelectOptionsProps = {}): IAvatarGroupSelectOption[] => {
  const { currentClinicId } = useClinicUser();

  const { data } = useGetClinicUsersQuery({
    variables: { clinicId: currentClinicId || '' },
    skip: !currentClinicId,
    fetchPolicy: GraphQLFetchPolicies.CacheFirst,
  });

  const assigneeOptions = useMemo(() => {
    if (!data?.users?.length) return [];
    return data.users
      .map((user) => {
        const { firstName, lastName, profilePic, id } = user;
        return {
          text: `${firstName} ${lastName}`,
          value: { id, firstName, lastName, photoUrl: profilePic || '' },
          isSelected: selectedUserIds ? selectedUserIds.some((selectedId) => selectedId === id) : false,
          icon: <ClinicAvatar clinicMember={user} showTooltip={false} size="xs" />,
        };
      })
      .sort((a, b) => a.text.localeCompare(b.text));
  }, [data, selectedUserIds]);

  return assigneeOptions;
};
